import React, { Fragment } from 'react'
import { getValueByPath } from '../Utilities/Functions';
import DataPagination from './DataPagination'
import DataTable from './DataTable'
import Paginator from './Paginator'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function SimpleTableHeader({ columns, sort, onSort }) {
    

    function handleSort(col) {
        if(onSort) {
            if(sort[col.property] === "ASC") onSort({ [col.property] : "DESC" });
            if(!sort[col.property] || sort[col.property] === "DESC") onSort({ [col.property] : "ASC" })
        }
    }

    return (
        <tr className="bg-light">
            {columns.map(col => {
                const sortOrd = sort && sort[col.property];
                const isSortable = !!onSort && col.property;
                return (
                    <th className="px-3 text-nowrap" style={{ cursor: isSortable && "pointer"}} onClick={() => handleSort(col)} {...col.cellProps}>
                        {col.header} { isSortable && (
                            sortOrd === "ASC" ? <FontAwesomeIcon icon="sort-up"/> :
                            sortOrd === "DESC" ? <FontAwesomeIcon icon="sort-down"/> :
                            <FontAwesomeIcon icon="sort"/> 
                        )}
                    </th>
                )
            })}
        </tr>
    );
}

export function SimpleTableCell({ rowData, column }) {
    const value = column.property && getValueByPath(rowData, column.property);

    return (
        <td className={column.className ? column.className(rowData) : ""} style={column.style ? column.style(rowData) : undefined} {...column.cellProps}>
            { column.render ? column.render(rowData) : column.format ? column.format(value) : value ? `${value}` : '-' }
        </td>
    )
}

export function SimpleTableRow({ index, rowData, columns, onClick, isSelected, className, style }) {
    let classes = [className];
    if(isSelected) classes.push("table-primary");

    return (
        <tr onClick={onClick} className={classes.join(' ')} style={{ cursor: onClick && 'pointer', ...style }}>
            { columns.map(col => <SimpleTableCell rowData={rowData} column={col}/> )}
        </tr>
    )
}

function SimplePaginatedTable({
    service, 
    
    page = 1, // 1 based
    setPage, //page change event
    limit = 10, //limit of items per page
    filter, //data filter definition
    sort, //sorting order
    onSort,
    columns, //columns that will be projected

    header = SimpleTableHeader, //how to render the header
    footer, //how to render the footer
    row = SimpleTableRow,    //how to render each row
    rowClass = () => {},
    
    selected, //selected item
    onSelect, //item select event
    disabled,

    className,
    forceUpdate = 0,

    
}, ref) {
    let classes = [];
    if(className) classes.push(className);
    if(!disabled && onSelect) classes.push("table-hover");

    return (
        <DataPagination service={service} limit={limit} page={page} filter={filter} sort={sort} forceUpdate={forceUpdate} ref={ref}>
            {({ data, page, lastPage, loading }) => (
                <Fragment>
                    <DataTable data={data} columns={columns} className={classes.join(' ')}
                        header={header} footer={footer} row={row}
                        selected={selected} onSelect={onSelect}
                        disabled={disabled} responsive
                        sort={sort} onSort={onSort}
                    />
                    <Paginator 
                        page={page} lastPage={lastPage}
                        setPage={setPage} loading={loading}
                    />
                </Fragment>
            )}
        </DataPagination>
    )
}

export default React.forwardRef(SimplePaginatedTable);